import React, { useState, useEffect, useRef } from 'react';

const PDFTextSelector = ({ onTextSelected }) => {
  const [isSelecting, setIsSelecting] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [endPos, setEndPos] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMouseDown = (e) => {
      setIsSelecting(true);
      setStartPos({ x: e.clientX, y: e.clientY });
    };

    const handleMouseMove = (e) => {
      if (isSelecting) {
        setEndPos({ x: e.clientX, y: e.clientY });
      }
    };

    const handleMouseUp = () => {
      setIsSelecting(false);
      const selection = window.getSelection();
      const selectedText = selection.toString();
      if (selectedText) {
        onTextSelected(selectedText, [startPos.x, startPos.y, endPos.x - startPos.x, endPos.y - startPos.y]);
      }
      selection.removeAllRanges();
    };

    container.addEventListener('mousedown', handleMouseDown);
    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseup', handleMouseUp);

    return () => {
      container.removeEventListener('mousedown', handleMouseDown);
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isSelecting, startPos, endPos, onTextSelected]);

  return (
    <div ref={containerRef} style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none' }}>
      {isSelecting && (
        <div
          style={{
            position: 'absolute',
            left: `${Math.min(startPos.x, endPos.x)}px`,
            top: `${Math.min(startPos.y, endPos.y)}px`,
            width: `${Math.abs(endPos.x - startPos.x)}px`,
            height: `${Math.abs(endPos.y - startPos.y)}px`,
            backgroundColor: 'rgba(0, 123, 255, 0.3)',
            pointerEvents: 'none',
          }}
        />
      )}
    </div>
  );
};

export default PDFTextSelector;
